// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__B6-tZ","centeredContent":"styles_centeredContent__5VzUp"};